var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatContainer"},[_c('div',{staticClass:"chatContent"},[_c('Chatlog',{ref:"chatlog",attrs:{"prologue":_vm.prologue,"logo":_vm.logo,"secret":_vm.secret},on:{"change":_vm.changeInput}}),_vm._v(" "),_c('ChatInput',{ref:"chatInput",on:{"send":_vm.sendLog,"changeLanguage":_vm.changeLanguage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }